import TableCommonHook from '@op/components/TableCommonHook';
import React, { useMemo } from 'react';
import { reviewsFormat } from '@op/utils/value';
import { useIntl } from 'umi';

export default function Index({
  data,
  columns = [],
  formatTimeFunc,
  maxHeight,
}: {
  columns?: Array<any>;
  data?: Array<any>;
  formatTimeFunc?: (value: string) => string;
  maxHeight?: number;
}) {
  const { formatMessage } = useIntl();
  const tableColumns = useMemo(() => {
    const allColumns: Array<any> = columns.map((item) => {
      const { name, value, formatValue = reviewsFormat } = item;
      const header: string | React.ReactNode = formatMessage({ id: name });

      return {
        header,
        key: value,
        alight: 'right',
        width: 160,
        render: (cvm: any) => formatValue(cvm[item.value]),
      };
    });

    return [
      {
        header: formatMessage({ id: 'Date' }),
        key: 'time',
        align: 'left',
        width: 130,
        fixed: 'left',
        render: ({ time }: any) => {
          return formatTimeFunc?.(time) || time;
        },
      },
      ...allColumns,
    ];
  }, [columns, formatMessage]);

  return (
    <TableCommonHook
      recordKey={tableColumns.map((item) => item.key)}
      columns={tableColumns}
      records={data}
      hasPageable={false}
      maxHeight={maxHeight}
      minWidth={'auto'}
    ></TableCommonHook>
  );
}
